import BaseQuery from "@/stateManagement/BaseQuery";
import { injectable } from "tsyringe";

import NudgesSettingsStore, {
    NudgesSettingsState,
} from "../stores/NudgesSettingsStore";

@injectable()
class NudgesSettingsQuery extends BaseQuery<NudgesSettingsState> {
    constructor(protected store: NudgesSettingsStore) {
        super(store);
    }

    isAllowed$ = this.select((state) => state.isAllowed);
    status$ = this.selectStatus();
}

export default NudgesSettingsQuery;
